module.exports = __webpack_public_path__ + "static/img/series-3_1_cover.cb7ce15.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sprite/series/series-3_1_cover.png
// module id = g83z
// module chunks = 0